<template>
  <div class="px-4">
    <article-card
      v-if="items[0]"
      v-bind="items[0]"
      size="lg"
      @click="$emit('click-item', items[0])"
      @delete="$emit('delete-item', items[0])"
    />
  </div>
</template>

<script>
import ArticleCard from './ArticleCard.vue'
import { useMode } from '../composables/mode'

export default {
  components: { ArticleCard },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    mode: {
      type: String,
      default: 'view',
      validator: (val) => ['view', 'edit'].includes(val)
    },
  },
  setup(props) {
    const { isEditMode } = useMode(props)

    return {
      isEditMode,
    }
  }
}
</script>